'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var RestException = /*#__PURE__*/function (_Error) {
  _inherits(RestException, _Error);

  var _super = _createSuper(RestException);

  function RestException(response) {
    var _this;

    _classCallCheck(this, RestException);

    _this = _super.call(this, '[HTTP ' + response.statusCode + '] Failed to execute request');
    var body = typeof response.body === 'string' ? JSON.parse(response.body) : response.body;
    _this.status = response.statusCode;
    _this.message = body.message;
    _this.code = body.code;
    _this.moreInfo = body.more_info;
    /* jshint ignore:line */

    _this.details = body.details;
    return _this;
  }

  return RestException;
}( /*#__PURE__*/_wrapNativeSuper(Error));

module.exports = RestException;